import FilePicker from './FilePicker';

export default FilePicker;
